import { ButtonGroup, Grid, InputLabel } from '@mui/material';
import React from 'react';
import { ButtonCheck, ButtonEmptyCheck } from './mini_components';

interface MultioptionProps {
    label:string,
    mode:"show" | "input",
    value:{"multioption" : string}[],
    name:string,
    options:{label:string, value:string}[],
    multiOptionSelected?: (value: string) => void;
}

const Multioption: React.FC<MultioptionProps> = ({ label, mode, name, value, options, multiOptionSelected }) => {
    const safeOptions = Array.isArray(options) ? options : [];
    const safeValue = Array.isArray(value) ? value : [];
    const optionButtons = safeOptions.map(option => {
        if(safeValue.length > 0 &&  safeValue.find((selection) => selection?.multioption === option.value)){
            return <ButtonCheck key={option.value} onClick={mode === "show" ?  undefined : () => multiOptionSelected?.(option.value)}>{option.label}</ButtonCheck>
        }
        return <ButtonEmptyCheck key={option.value} onClick={mode === "show" ? undefined : () => multiOptionSelected?.(option.value) }>{option.label}</ButtonEmptyCheck>
    });
    // Read-only field groups (e.g. lesion_diagnoses, body_map_code) often carry
    // stored [{multioption: code}] without the full option catalog on the schema.
    if (mode === 'show') {
        safeValue.forEach((selection, index) => {
            const code = selection?.multioption;
            if (!code || safeOptions.some((option) => option.value === code)) {
                return;
            }
            optionButtons.push(
                <ButtonCheck key={`selected-${code}-${index}`}>{code}</ButtonCheck>,
            );
        });
    }
    return (
        <Grid container style={{paddingTop:'0.5rem'}}>
        {
            !label.includes("general.") &&
            <Grid item  xs={12}>
                <InputLabel id={name}>{label}</InputLabel>
            </Grid>
        }
        <Grid item  xs={12}>
            <ButtonGroup color="primary" aria-label="outlined primary button group" style={{flexWrap: "wrap"}}>
                {optionButtons}
            </ButtonGroup>
        </Grid>
    </Grid>
    );
};

export default Multioption;
